// extracted by mini-css-extract-plugin
export default {"figure":"Figure-module__figure-StQRM0","caption":"Figure-module__caption-Th1APa","image":"Figure-module__image-Nc8I9c","isFull":"Figure-module__isFull-S0c0MA"};